export default "__VITE_ASSET__BGLHSX_g__"